// extracted by mini-css-extract-plugin
export default {"container":"AppSidebarTimer_container_FvIUR","time":"AppSidebarTimer_time_ot4wq","date":"AppSidebarTimer_date_xC4OL"};